import { render } from "./VideoBlock.vue?vue&type=template&id=0783d8a4&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"

import "./VideoBlock.vue?vue&type=style&index=0&id=0783d8a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0783d8a4"]])

export default __exports__